import { CountryDTO } from './countriesTypes'

import { apiCatalogs, endpoints } from '@/api'

export async function fetchCountries(): Promise<{ countries: CountryDTO[] }> {
  const res = await apiCatalogs.get<{ countries: CountryDTO[] }>(
    endpoints.catalogs.countries.getCountries,
  )
  return res.data
}

export const countriesApi = {
  fetchCountries,
}
